// extracted by mini-css-extract-plugin
export default {"detailsContainer":"inspectionDetails_detailsContainer__-dbds"};